// extracted by mini-css-extract-plugin
export default {"submitWrap":"AdminAddProgramForm_submitWrap__aGICr"};